import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { WithdrawalInCryptocurrencyStepUI } from "@src/widgets/onboarding/ui/tours/AccountTopUp/WithdrawalInCryptocurrencyStepUI"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class WithdrawalInCryptocurrencyStep extends TourStepBase {
  component = WithdrawalInCryptocurrencyStepUI
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_WithdrawalInCryptocurrencyStep`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_WITHDRAW_FORM_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM,
    })
  }

  action() {
    return router.navigate({
      pathname: generatePath(paths.withdraw, {
        network: "tron",
        symbol: "TRX",
      }),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      subtitle: "Step 2: Submit a request",
      title: "Withdrawal in Cryptocurrency",
    }
  }
}
